import { useEffect, useState } from 'react';
import { useGetCurrentUserSettings } from '../services/react-query/users/useGetCurrentUserSettings';
import { useUpdateUserDashboardSettings } from '../services/react-query/users/useUpdateUserDashboardSettings';
import { DashboardModuleSettings, DashboardSettingPayload, UserConfigurableModule } from '../types/User';

export const useUserDashboardSettings = (module: UserConfigurableModule) => {
  const { data: userSettingsData } = useGetCurrentUserSettings();
  const { mutate: updateUserSettings } = useUpdateUserDashboardSettings();

  const defaultSettings: DashboardModuleSettings = { ownership: 'all', filters: {} };
  const [dashboardSettings, setDashboardSettings] = useState<DashboardModuleSettings>(defaultSettings);

  useEffect(() => {
    setDashboardSettings(userSettingsData?.settings?.dashboard?.[module] ?? defaultSettings);
  }, [userSettingsData, module]);

  const updateSettings = (updates: Partial<DashboardModuleSettings>) => {
    const updatedSettings: DashboardModuleSettings = {
      ownership: updates.ownership ?? dashboardSettings.ownership,
      filters: { ...dashboardSettings.filters, ...updates.filters },
    };

    setDashboardSettings(updatedSettings);

    const updatedPayload: DashboardSettingPayload = {
      dashboard: {
        ...userSettingsData?.settings?.dashboard,
        [module]: updatedSettings,
      },
    };

    updateUserSettings(updatedPayload);
  };

  return { dashboardSettings, updateSettings };
};
